/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { IS_DEV_ENV, IS_PROD_ENV } from '../env/constants/environment'

/* eslint-disable @typescript-eslint/no-explicit-any */
export const enum BrowserLogCategory {
	Common = 'Common',
	Error = 'Error',
	Warning = 'Warning'
}

const CommonLog = (
	mode: 'dev' | 'prod' | 'any' = 'dev',
	category: BrowserLogCategory,
	title?: any,
	...message: any[]
) => {
	if (mode == 'dev' && !IS_DEV_ENV) return
	if (mode == 'prod' && !IS_PROD_ENV) return

	console.log('--------------------')
	switch (category) {
		case BrowserLogCategory.Common: {
			if (title != null) {
				console.log(title, ...message)
			}
			return
		}
		case BrowserLogCategory.Error: {
			if (title != null) {
				console.error(title, ...message)
			}
			return
		}
		case BrowserLogCategory.Warning: {
			if (title != null) {
				console.warn(title, ...message)
			}
			return
		}
		default:
			console.log(message)
	}
	console.log('--------------------')
	console.log()
}

export const DevLog = (category: BrowserLogCategory, title?: any, ...message: any[]) => {
	CommonLog('dev', category, title, message)
}

export const Log = (category: BrowserLogCategory, title?: any, ...message: any[]) => {
	CommonLog('any', category, title, message)
}
